import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import React, { FC } from 'react';
import ResourceList from './list/ResourceList';

const ResourcesPage: FC = React.memo(function ResourcesPage() {
  const { resourceType } = pages.resources.useParams();
  if (resourceType === null || resourceType === undefined) return null;
  return <ResourceList resourceType={resourceType} />;
});

export default ResourcesPage;
